export const BASE_CLASS = 'fm-input-field';

export const getClass = (childClass: TemplateStringsArray) =>
  `${BASE_CLASS}${childClass}`;
